var _rect, _polygon, _polygon2, _rect2, _polygon3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMedication = function SvgMedication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.6,
    y: 14.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3.6235 54.6291)",
    width: 4.3,
    height: 17.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "89.3,0 73.7,15.6 70.7,12.6 67,16.3 74.4,23.7 78.1,20 75.1,17 90.7,1.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.1,53.4 23.1,61.4 5.8,78.7 12,84.8 29.3,67.6 37.2,75.6 38.7,74.1 16.6,52 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 75.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -57.3358 29.379)",
    width: 2,
    height: 17.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.2,51.4 20.8,53.4 36.9,69.5 72.8,34 56.7,17.9 51.7,22.9 56.7,28 55.3,29.4 50.2,24.4 46.3,28.3 49,31.1 47.5,32.5 44.8,29.8 40.8,33.7 45.9,38.8 44.5,40.2 39.4,35.2 35.4,39.1 38.2,41.9 36.7,43.3 34,40.6 30,44.5 35.1,49.6 33.7,51 28.6,46 24.6,49.9 27.4,52.7 25.9,54.1 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.4,58.5c-4.7,0-8.6,3.9-8.6,8.6v9.8H98v-9.8C98,62.4,94.1,58.5,89.4,58.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,88.6c0,4.7,3.8,8.6,8.6,8.6s8.6-3.9,8.6-8.6v-9.8H80.8V88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,68.1c0,1.9,0.7,3.7,1.8,5.1l11.7-11.7c-1.4-1.1-3.2-1.8-5.1-1.8C51.9,59.8,48.1,63.5,48.1,68.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,68.1c0-1.9-0.7-3.7-1.8-5.1L51.3,74.6c1.4,1.1,3.2,1.8,5.1,1.8C61,76.4,64.8,72.7,64.8,68.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,94.1c1.7,1.4,3.8,2.2,6.1,2.2c5.3,0,9.7-4.3,9.7-9.7c0-2.3-0.8-4.4-2.2-6.1L61.5,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7,79.1c-1.7-1.4-3.8-2.2-6.1-2.2c-5.3,0-9.7,4.3-9.7,9.7c0,2.3,0.8,4.4,2.2,6.1L73.7,79.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 33.8,
    transform: "matrix(0.7038 -0.7104 0.7104 0.7038 -15.3329 32.8128)",
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 23.4,
    transform: "matrix(0.7023 -0.7119 0.7119 0.7023 -4.8747 37.1482)",
    width: 3.2,
    height: 2
  }))));
};

export default __webpack_public_path__ + "static/media/Medication.177c2671.svg";
export { SvgMedication as ReactComponent };